import { useState } from "react";
import Modal from "react-modal";
import cx from "classnames";

import styles from "./ModalLauncher.scss";

export type ModalLauncherRenderProps = {
  open: () => void;
  close: () => void;
};

interface ModalLauncherProps {
  isInitiallyOpen?: boolean;
  trigger?: React.ReactNode;
  header?: () => React.ReactNode;
  contentLabel?: string;
  wide?: boolean;
  children: React.ReactNode;
  closeBtnVisible?: boolean;
  isOpen?: boolean;
  customOverlayStyles?: string;
  customContentStyles?: string;
  onTriggerClick?: () => void;
  isDisabled?: boolean;
}

const ModalLauncher = ({
  isInitiallyOpen = false,
  trigger,
  header,
  children,
  contentLabel = "",
  wide = false,
  closeBtnVisible = true,
  customOverlayStyles = "",
  customContentStyles = "",
  onTriggerClick,
  isDisabled = false
}: ModalLauncherProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(isInitiallyOpen);

  const close = () => setIsOpen(false);
  const open = () => setIsOpen(true);

  return (
    <>
      {trigger && (
        <div
          onClick={() => {
            //optional aditional trigger logic
            if (onTriggerClick) {
              onTriggerClick();
            }
            if (!isDisabled) {
              open();
            }
          }}
        >
          {trigger}
        </div>
      )}
      <Modal
        className={cx("content", customContentStyles, { [styles.wide]: wide })}
        overlayClassName={cx("overlay", customOverlayStyles)}
        isOpen={isOpen}
        onRequestClose={() => {
          if (closeBtnVisible) {
            close();
          }
        }}
        contentLabel={contentLabel}
        closeTimeoutMS={300}
        // @ts-ignore:next-line
        ariaHideApp={!process.env.NODE_ENV === "test"}
      >
        {header && <h1 className={styles.header}>{header()}</h1>}
        {children}
        {closeBtnVisible && (
          <button
            type="button"
            className={styles.close}
            onClick={close}
            data-testid="closeButton"
            aria-label="schließen"
          >
            &#215;
          </button>
        )}
      </Modal>
    </>
  );
};

export default ModalLauncher;
